// extracted by mini-css-extract-plugin
export default {"root":"_3bEucP4S","fullWidth":"_3feTH91h"};